export const EventParentCategoryCode = 'ZET';

export const EventModeMap = {
  PAY_PER_ATTENDEE: 'PAY_PER_ATTENDEE',
  SUBSCRIPTION: 'SUBSCRIPTION',
};

export const ze_only_overage_price_list_key = "ze_only_overage_price_list";
